import { Link, NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import PaypalPaymentComponent from '../frontend/PaypalPaymentComponent';

import swal from 'sweetalert';

import logo from '../../assets/frontend/images/logo.png';

const DonatePanel = ({ onClose, track, tracklist }) => {

  const hasTrack = track !== null && track !== undefined;
  const hasTracklist = tracklist !== null && tracklist !== undefined;

  function getTestCredentials() {
    swal('PayPal Test Credentials', '\nemail=\nsb-bxppw43749260@personal.example.com\n\n\npassword=\nsb-bxppw43749260', 'info');
  }

  return (
    <div className="options-content">
      <div className="panel large p-10">
        <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">

          {hasTrack && hasTracklist ? (
            tracklist.type === 'liked' && track.tracklistImageURL ? (
              <span className="center-everything b1-555">
                <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
              </span>
            ) : (
              tracklist.type === 'liked' ? (
                <span className="center-everything b1-555">
                  <img src={tracklist.image_url} alt={tracklist.title} className="hide-for-small-only" width="50" />
                  <img src={tracklist.image_url} alt={tracklist.title} className="show-for-small-only" width="35" />
                </span>
              ) : (
                <span className="center-everything b1-555">
                  <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                  <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                </span>
              )
            )
              (tracklist.type === 'liked' && track.tracklistTitle ? (
                <span className="">
                  <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                  <div className="font-source-sans font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{track ? track.tracklistTitle : ''}</div>
                </span>
              ) : (
                tracklist.type !== 'liked' ? (
                  <span className="">
                    <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                    <div className="font-source-sans font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{tracklist ? tracklist.title : ''}</div>
                  </span>
                ) : (
                  <span className="">
                    <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{tracklist ? tracklist.title : ''}</span>
                  </span>
                )
              ))
          ) : (
            <span className="">
              <div className="horizontal-container justify-left gap-md">
                <span className="hide-for-920px">
                  <img src={logo} className="" alt="logo" width="70" />
                </span>
                <span className="show-for-920px">
                  <img src={logo} className="hide-for-small-only" alt="logo" width="60" />
                  <img src={logo} className="show-for-small-only" alt="logo" width="50" />
                </span>
                <span>
                  <div className="font-libre-baskerville font-size-24l-20m-18s font-weight-800 txt-feliz-blue pt-5">Love Leads</div>
                  <div className="font-libre-baskerville font-size-24l-20m-18s font-weight-500 txt-feliz-blue pt-10l-5s">&nbsp;&nbsp;&nbsp;<i>the</i> Way</div>
                </span>
              </div>
            </span>
          )}
        </div>

        <div className="ptb-15">
          <PaypalPaymentComponent track={track} tracklist={tracklist} />
        </div>

        <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
          <Link className="font-poppins font-size-18l-16m font-weight-500 align-left" onClick={getTestCredentials}>PayPal Test Credentials</Link>
          <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
        </div>

      </div>
    </div>
  );
};

export default DonatePanel;
